export default __webpack_public_path__ + "static/media/hostaway.13c232fb.png";